export const Colors = {
    buttonColor: '#44A08D',
        buttonHoverColor: '#3E8E41',
        buttonActiveColor: '#2E6E33',
        primaryColor:'#f39c12',
        primaryColor1:'#d27e00',
        bg:'#090D12',
        bgcard:'#242424',
        secondary:'white'
    };
    export default Colors;